import { render, staticRenderFns } from "./TableRiskAppraisalBsgs.vue?vue&type=template&id=54f5ff35&scoped=true"
import script from "./TableRiskAppraisalBsgs.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisalBsgs.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisalBsgs.vue?vue&type=style&index=0&id=54f5ff35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f5ff35",
  null
  
)

export default component.exports